<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师月度绩效考评' label2="评分详细" url="/achievement/teach/scorerecordchecklist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <div style="width: 100%;height: 40px;line-height: 40px;text-align: center;font-size: 18px;">
            <span style="text-decoration: underline;">{{this.secname}}</span><span style="text-decoration: underline;padding-left: 10px;">{{this.cpidate|formatDate}}</span>月带教老师考核汇总表
          </div>
          <div style="width: 100%;overflow: auto;">
            <div v-html="tabScore">
            </div>
          </div>
          <div style="margin: 15px;">
            <div style="font-size: 18px;">优秀评分理由</div>
            <el-table :data="remarkTable">
              <el-table-column prop="StuName" label="带教老师" width="150">
              </el-table-column>
              <el-table-column prop="StuNo" label="工号" width="150">
              </el-table-column>
              <el-table-column prop="ETDContent" label="评分项" width="200">
              </el-table-column>
              <el-table-column prop="ContentRemark" label="理由">
              </el-table-column>
            </el-table>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">签字凭证：</label>
            <div class="col-xl-10">
              <el-table v-loading="loading" :data="tableFileData" stripe style="width: 100%" size="medium" v-if="tableFileData.length != 0">
                <el-table-column label="附件名">
                  <template slot-scope="scope">
                    {{scope.row.FileName}}<span style="color: #409EFF;cursor: pointer;padding-left: 10px;" @click="See(scope.row)">[查看]</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">审核意见：</label>
            <div class="col-xl-10">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.cpicinfo">
              </el-input>
            </div>
          </div>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
          <div class="m-form__actions m-form__actions--solid">
            <div class="row">
              <div class="col-lg-12 m--align-center">
                <el-button type="success" icon="el-icon-check" @click="Check(1)" v-loading.fullscreen.lock="fullscreenLoading">通过</el-button>
                <el-button type="danger" icon="el-icon-refresh" @click="Check(2)" v-loading.fullscreen.lock="fullscreenLoading">退回</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="凭证查看" :visible.sync="dialogImgVisible">
      <el-image style="width: 100%;" :src="imgurl"></el-image>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'TeachScoreRecordCheck',
    data() {
      return {
        form: {
          token: '',
          id: '',
          cpicinfo: '',
          cpicstatus: '',
          cpitype: 2,
        },
        condition: {
          token: '',
          id: ''
        },
        tabScore: '',
        cpifile: '',
        cpifiledesc: '',
        cpicstatusname: '',
        fullscreenLoading: false,
        secname: '',
        cpidate: '',
        tableFileData: [],
        FileGuid: '',
        dialogImgVisible: false,
        imgurl: '',
        remarkTable:[]
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      }
    },
    methods: {
      See: function(row) {
        this.imgurl = this.$utils.Url.zpgl + '/file/' + row.FileName
        this.dialogImgVisible = true
      },
      LoadFileList: function() {
        this.loading = true
        var args = {
          token: this.condition.token,
          guid: this.FileGuid
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/FileListByGuid', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableFileData = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tableData = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      LoadCPIDetail: function() {
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/TeachCPIDetail', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.tabScore = res.data.Data
              that.LoadCPIRemark()
              loading.close()
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
              loading.close()
            }
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
            loading.close()
          })
      },
      LoadCPIRemark: function() {
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetCPIRemark', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.remarkTable = res.data.Data
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            that.remarkTable = []
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LoadCPIInfo: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ViewInfo', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.cpifile = res.data.Data.CPIFile
              this.cpifiledesc = res.data.Data.CPIFileDesc
              this.cpicstatusname = res.data.Data.CPICStatusName
              this.cpicinfo = res.data.Data.CPICInfo
              this.FileGuid = res.data.Data.CPIRemark4
              this.LoadFileList()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            this.tabHead = ''
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      Check: function(state) {
        this.form.cpicstatus = state
        var message = ''
        if (state === 1) {
          message = '确认审核通过该带教老师绩效考评信息？'
        } else {
          message = '确认退回该带教老师绩效考评信息？'
        }
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/Check', this.form)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '审核成功',
                  type: 'success'
                })
                console.log('刷新页面')
                this.$router.push('/main/achievement/teach/scorerecordchecklist')
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
              this.fullscreenLoading = false
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '提交失败',
                type: 'error'
              })
              this.fullscreenLoading = false
            })
        }).catch(() => {})
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.condition.token = sessionStorage.getItem('token')
      this.condition.id = this.$route.params.id
      this.form.id = this.$route.params.cid
      this.secname = this.$route.params.secname
      this.cpidate = this.$route.params.cpidate
      this.LoadCPIDetail()
      this.LoadCPIInfo()
    }
  }
</script>

<style scoped="scoped">
  @import '../../../assets/css/tecscore.css'
</style>
